import { FC, useId } from 'react';
import { twMerge } from 'tailwind-merge';

import { IconProps } from './icon.types';

export const GlobeIcon: FC<IconProps> = ({ iconColor = '#2565C8', className, ...props }) => {
  const rawId = useId().replace(/:/g, '');
  const clipOuterId = `${rawId}-globe-clip-outer`;
  const clipInnerId = `${rawId}-globe-clip-inner`;

  return (
    <svg
      className={twMerge('shrink-0', className)}
      fill="none"
      height="32"
      viewBox="0 0 32 32"
      width="32"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath={`url(#${clipOuterId})`}>
        <g clipPath={`url(#${clipInnerId})`}>
          <path
            d="M6.29926 20.0182C5.77159 18.7443 5.5 17.3789 5.5 16C5.5 13.2152 6.60625 10.5445 8.57538 8.57538C10.5445 6.60625 13.2152 5.5 16 5.5C18.7848 5.5 21.4555 6.60625 23.4246 8.57538C25.3938 10.5445 26.5 13.2152 26.5 16C26.5 17.3789 26.2284 18.7443 25.7007 20.0182C25.1731 21.2921 24.3996 22.4496 23.4246 23.4246C22.4496 24.3996 21.2921 25.1731 20.0182 25.7007C18.7443 26.2284 17.3789 26.5 16 26.5C14.6211 26.5 13.2557 26.2284 11.9818 25.7007C10.7079 25.1731 9.55039 24.3996 8.57538 23.4246C7.60036 22.4496 6.82694 21.2921 6.29926 20.0182Z"
            stroke={iconColor}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.75"
          />
          <path
            d="M6.19993 12.5H25.7999"
            stroke={iconColor}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.75"
          />
          <path
            d="M6.19993 19.5H25.7999"
            stroke={iconColor}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.75"
          />
          <path
            d="M15.4167 5.5C13.4513 8.64955 12.4093 12.2875 12.4093 16C12.4093 19.7125 13.4513 23.3505 15.4167 26.5"
            stroke={iconColor}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.75"
          />
          <path
            d="M16.5833 5.5C18.5487 8.64955 19.5907 12.2875 19.5907 16C19.5907 19.7125 18.5487 23.3505 16.5833 26.5"
            stroke={iconColor}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.75"
          />
        </g>
      </g>
      <defs>
        <clipPath id={clipOuterId}>
          <rect fill="white" height="32" width="32" />
        </clipPath>
        <clipPath id={clipInnerId}>
          <rect fill="white" height="28" transform="translate(2 2)" width="28" />
        </clipPath>
      </defs>
    </svg>
  );
};
